import moment from "moment";
import { ProductCategory, ProductTypeCommon } from "@utils/constants";

const updateTabOptionBadgeCount = (tabOptions, key, badgeCount) => {
  return tabOptions.map((option) =>
    option.key === key ? { ...option, badgeCount } : option
  );
};

const renderDateTime = (date: string | Date, format: string) => {
  return moment(new Date(date)).format(format);
};

const getProductTypeFromRequest = (request: string): ProductCategory => {
  const lowercaseRequest = request?.toLowerCase();

  if (lowercaseRequest?.includes(ProductCategory.GEMSTONE)) {
    return ProductCategory.GEMSTONE;
  }

  if (
    lowercaseRequest?.includes(ProductCategory.JEWELRY) ||
    lowercaseRequest?.includes(ProductCategory.LABGROWN_JEWELRY)
  ) {
    return ProductCategory.JEWELRY;
  }

  if (
    lowercaseRequest?.includes(ProductCategory.LAB_GROWN_DIAMOND) ||
    lowercaseRequest?.includes("labgrowndiamond")
  ) {
    return ProductCategory.LAB_GROWN_DIAMOND;
  }

  if (lowercaseRequest?.includes(ProductCategory.DIAMOND)) {
    return ProductCategory.DIAMOND;
  }

  return ProductCategory.DEFAULT;
};

const setProductTypeFromRequest = (request: string, sub_type?: string) => {
  let productType = ProductCategory.DIAMOND;
  let bulkProductName = "Diamond";
  let productIcon = "upd-diamonds";
  let theme = "diam";
  if (request.toLowerCase().includes(ProductCategory.GEMSTONE)) {
    productType = ProductCategory.GEMSTONE;
    bulkProductName = "Gemstone";
    productIcon = "upd-gemstones";
    theme = "gem";
  } else if (request.toLowerCase().includes(ProductCategory.JEWELRY)) {
    if (sub_type === ProductTypeCommon.LABGROWN_JEWELRY_SUB_TYPE) {
      productType = ProductCategory.JEWELRY;
      bulkProductName = "Lab-Grown Jewelry";
      productIcon = "upd-labJewelry";
      theme = "jewelry";
    } else {
      productType = ProductCategory.JEWELRY;
      bulkProductName = "Jewelry";
      productIcon = "upd-jewelry";
      theme = "jewelry";
    }
  } else if (
    request.toLowerCase().includes(ProductCategory.LAB_GROWN_DIAMOND)
  ) {
    productType = ProductCategory.LAB_GROWN_DIAMOND;
    bulkProductName = "LabGrownDiamond";
    productIcon = "upd-labGrown";
    theme = "lab";
  } else {
    productType = ProductCategory.DIAMOND;
    bulkProductName = "Diamond";
    productIcon = "upd-diamonds";
    theme = "diam";
  }

  return {
    productType,
    bulkProductName,
    productIcon,
    theme,
  };
};

const setProductTypeFromStockType = (stock_type?: string) => {
  let productType = ProductCategory.DEFAULT;
  let bulkProductName = "Default";
  let productIcon = "upd-diamonds";
  let theme = "main";
  if (stock_type === ProductCategory.GEMSTONE) {
    productType = ProductCategory.GEMSTONE;
    bulkProductName = "Gemstone";
    productIcon = "upd-gemstones";
    theme = "gem";
  } else if (stock_type === ProductCategory.JEWELRY) {
    productType = ProductCategory.JEWELRY;
    bulkProductName = "Jewelry";
    productIcon = "upd-jewelry";
    theme = "jewelry";
  } else if (stock_type === ProductCategory.LAB_GROWN_DIAMOND) {
    productType = ProductCategory.LAB_GROWN_DIAMOND;
    bulkProductName = "LabGrownDiamond";
    productIcon = "upd-labGrown";
    theme = "lab";
  } else if (stock_type === ProductCategory.DIAMOND) {
    productType = ProductCategory.DIAMOND;
    bulkProductName = "Diamond";
    productIcon = "upd-diamonds";
    theme = "diam";
  }

  return {
    productType,
    bulkProductName,
    productIcon,
    theme,
  };
};

const renderRequestStatus = (status: string, t: any) => {
  let colorCode = "";
  let backgroundColor = "";
  switch (
    String(status ?? "")
      .trim()
      .toLowerCase()
  ) {
    case "pending":
      colorCode = "warn-01";
      status = t("requestHistoryDetail.status.pending.text");
      backgroundColor = "warn-02";
      break;
    case "partially pending":
      colorCode = "warn-01";
      status = t("requestHistoryDetail.status.partiallyPending.text");
      backgroundColor = "warn-02";
      break;
    case "accepted":
      colorCode = "success-01";
      status = t("requestHistoryDetail.status.accepted.text");
      backgroundColor = "success-02";
      break;
    case "partially accepted":
      colorCode = "success-01";
      status = t("requestHistoryDetail.status.partiallyAccepted.text");
      backgroundColor = "success-02";
      break;
    case "online_paypal":
      colorCode = "success-01";
      status = t("requestHistoryDetail.status.onlinePaypal.text");
      backgroundColor = "success-02";
      break;
    case "decline":
    case "declined":
      colorCode = "error-01";
      status = t("requestHistoryDetail.status.declined.text");
      backgroundColor = "error-02";
      break;
    case "payment_failed":
      colorCode = "error-01";
      status = t("requestHistoryDetail.status.paymentFailed.text");
      backgroundColor = "error-02";
      break;
    case "withdraw":
    case "withdrawn":
      colorCode = "error-01";
      status = t("requestHistoryDetail.status.withdrawn.text");
      backgroundColor = "error-02";
      break;
    case "expired":
      colorCode = "error-01";
      status = t("requestHistoryDetail.status.expired.text");
      backgroundColor = "error-02";
      break;
    case "closed":
      colorCode = "error-01";
      status = t("requestHistoryDetail.status.closed.text", "Closed");
      backgroundColor = "error-02";
      break;
    case "received":
      colorCode = "success-01";
      status = t("requestHistoryDetail.status.received.text");
      backgroundColor = "success-02";
      break;
    case "submitted":
      colorCode = "success-01";
      status = t("requestHistoryDetail.status.submitted.text");
      backgroundColor = "success-02";
      break;
    default:
      colorCode = "warn-01";
      status = t("requestHistoryDetail.status.pending.text");
      backgroundColor = "warn-02";
      break;
  }
  return {
    colorCode,
    status,
    backgroundColor,
  };
};

export {
  updateTabOptionBadgeCount,
  renderDateTime,
  setProductTypeFromRequest,
  renderRequestStatus,
  getProductTypeFromRequest,
  setProductTypeFromStockType,
};
